import React from "react";
import { Mail } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_cf4fc7f2-a73a-4fe6-9ce3-8070ac060fc8/artifacts/f8wsr7qm_Logo-01.jpg";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[var(--paper)] py-14"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="iAriya AI"
              className="h-14 w-auto object-contain"
            />
          </div>
          <p className="mt-4 text-stone-700 max-w-sm">
            Practical AI assistants & workflow automations for UK solo
            entrepreneurs and small businesses.
          </p>
        </div>

        <div>
          <p className="font-display font-extrabold text-lg mb-3">Explore</p>
          <ul className="space-y-2 text-stone-700">
            <li><a href="#services" className="hover:text-[var(--pink)] font-semibold">Services</a></li>
            <li><a href="#who-we-help" className="hover:text-[var(--pink)] font-semibold">Who We Help</a></li>
            <li><a href="#pricing" className="hover:text-[var(--pink)] font-semibold">Pricing</a></li>
            <li><a href="#faq" className="hover:text-[var(--pink)] font-semibold">FAQ</a></li>
          </ul>
        </div>

        <div>
          <p className="font-display font-extrabold text-lg mb-3">Get in touch</p>
          <a
            href="mailto:eventinfo@iariya.com"
            className="inline-flex items-center gap-2 font-semibold text-[var(--blue)] hover:underline"
            data-testid="footer-email-link"
          >
            <Mail size={18} /> eventinfo@iariya.com
          </a>
          <p className="mt-4 text-sm text-stone-600">
            © {new Date().getFullYear()} iAriya AI · Made with care in the UK.
          </p>
        </div>
      </div>
    </footer>
  );
};
